import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';
import { BlockchainElement } from '@/views/MyWatchesView/components/BlockchainFAQ/components/BlockchainElement';

export const Blockchain = styled(BlockchainElement)`
  background-color: transparent !important;
  margin: 0;
  & > header {
    border: none;

    & > button {
      ${({ theme }) => css`
        color: ${theme.colors.primaryBlue};
        background-color: transparent !important;
        padding: 0;
        text-transform: uppercase;
        justify-content: space-between;
      `}
    }
  }
`;

export const Desc = styled(Typography)`
  word-break: normal;
  padding: 0;
`;

export const Text = styled(Typography)`
  line-height: 1rem;
  margin-top: 0.3em;
  min-height: 1rem;
`;

export const Title = styled(Typography)`
  height: 40px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primaryBlue};
`;
